import 'lenis/dist/lenis.css';
import '@/styles/fonts.css';
import '@/styles/tokens.css';
import '@/styles/base.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { AppServicesContext } from '@/app/AppServicesContext';
import { composeApp } from '@/app/composition';
import { ContentContext } from '@/content/ContentContext';
import { siteContent } from '@/content/site.fr';

const container = document.getElementById('root');
if (!container) throw new Error('Élément #root introuvable dans index.html');

const services = composeApp(window);

createRoot(container).render(
  <StrictMode>
    <AppServicesContext value={services}>
      <ContentContext value={siteContent}>
        <App />
      </ContentContext>
    </AppServicesContext>
  </StrictMode>,
);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    services.dispose();
  });
}
